module.exports = __webpack_public_path__ + "img/icon-letter-n.6533d2c2.svg";